import { useTranslation } from "react-i18next";
import { Leaf } from "lucide-react";

/**
 * Bloque medioambiental de `/impacto` — CO₂e evitado.
 *
 * iter43 · Se elimina la card "Incidencias resueltas %" (regla Fase 2:
 * "sin estados vacíos silenciosos"). El upstream no publica hoy el estado
 * de cierre de las detecciones (todas llegan como "NUEVA"), por lo que
 * mostrar 0 % da una impresión falsa de "no se resuelve nada".
 *
 * iter43 · El KPI "CO₂e evitado" nunca muestra `—`: si no existe baseline
 * vs actual, se aplica el fallback conservador `min_plausible_km_sla`
 * (documentado en /app/memory/METODOLOGIA_CO2.md).
 */
export default function ImpactoEnvironment({ kpis = {} }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.startsWith("es") ? "es" : "gl";
  const avoided = kpis.co2e_evitado_toneladas;
  const method = kpis.co2e_evitado_estimation_method || "real";
  const isEstimated = method !== "real";
  const hasValue = avoided !== null && avoided !== undefined;

  return (
    <div
      className="grid grid-cols-1 gap-5"
      data-testid="impacto-env-grid"
    >
      <div
        className="rounded-2xl border hairline bg-white p-8 flex flex-col justify-between min-h-[220px] max-w-2xl"
        data-testid="impacto-env-avoided"
      >
        <div className="flex items-center gap-3">
          <Leaf size={18} className="text-salnes-emerald" />
          <div className="text-[11px] uppercase tracking-[0.22em] text-salnes-stone">
            {t("fase7.kpi_co2e_avoided")}
          </div>
        </div>
        <div className="font-serif text-5xl lg:text-6xl text-salnes-ink mt-6 tabular-nums">
          {hasValue ? avoided.toFixed(2) : "0.00"}
          <span className="text-lg text-salnes-stone ml-3">t CO₂e</span>
        </div>
        {isEstimated && (
          <div
            className="mt-4 inline-flex items-center gap-1.5 self-start rounded-full bg-salnes-sand/60 px-2.5 py-1 text-[10px] uppercase tracking-[0.18em] text-salnes-stone"
            title={
              lang === "es"
                ? "Estimación conservadora (piso mínimo). Sin baseline oficial se aplica una reducción del 5 % sobre el mínimo plausible de emisiones de flota. Referencia: EU CIVITAS · digitalización de flotas RSU. Metodología: /app/memory/METODOLOGIA_CO2.md."
                : "Estimación conservadora (piso mínimo). Sen baseline oficial aplícase unha reducción do 5 % sobre o mínimo plausible de emisións de frota. Referencia: EU CIVITAS · dixitalización de frotas RSU. Metodoloxía: /app/memory/METODOLOGIA_CO2.md."
            }
            data-testid="impacto-env-avoided-estimation-badge"
          >
            <span aria-hidden>◐</span>
            {lang === "es"
              ? "Estimación conservadora · mín. plausible"
              : "Estimación conservadora · mín. plausible"}
          </div>
        )}
      </div>
    </div>
  );
}
